import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function imageUrl(url) {
  if (!url) return "";
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const ACCENTS = {
  gold: { text: "text-[#E2C08D]", border: "border-[#E2C08D]/30", bg: "bg-[#E2C08D]/10", dot: "#E2C08D" },
  sky: { text: "text-[#38BDF8]", border: "border-[#38BDF8]/30", bg: "bg-[#38BDF8]/10", dot: "#38BDF8" },
  green: { text: "text-[#10B981]", border: "border-[#10B981]/30", bg: "bg-[#10B981]/10", dot: "#10B981" },
  rose: { text: "text-[#FB7185]", border: "border-[#FB7185]/30", bg: "bg-[#FB7185]/10", dot: "#FB7185" },
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return err?.message || "Something went wrong";
}
